import { render, staticRenderFns } from "./ImportacionMetalicos.vue?vue&type=template&id=48ca39f0&"
import script from "./ImportacionMetalicos.vue?vue&type=script&lang=js&"
export * from "./ImportacionMetalicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports